<template>
  <div class="shadow" :class="{ 'border-top': active }">
    <div class="help">
      <div :class="[help == 'fragmap' ? 'help-on' : 'help-off']">
        <h2 class="name">FragMap</h2>
        <v-row>
          Explore the SILCS FragMap for Factor Xa. The crystal structure is also
          displayed. Toggle the generic FragMap types "on" and "off" to see
          where these groups interact most favorably with the protein surface.
          Overlap between the FragMap densities and the crystallographic ligand
          can be observed. The default GFE value of -1.0 kcal/mol. moving the
          slider to different GFE values reveals areas of higher favorability
          (more negative GFE), or areas of unfavorability (more positive GFE
          values). Download the SILCS Sampler to look at FragMaps in more
          detail. The FragMap viewer plugin for PyMol or VMD includes more
          features to try out!
        </v-row>
      </div>
      <div :class="[help == 'fragmap.excl' ? 'help-on' : 'help-off']">
        <h2 class="name">Exclusion Map</h2>
        <v-row>
          Exclusion map shows the region where no probe molecule and no water
          molecule have visited. Combined with the protein surface map, the
          exclusion map can identify sites where the target protein exhibits
          flexibility.
        </v-row>
      </div>
      <div :class="[help == 'fragmap.apolar' ? 'help-on' : 'help-off']">
        <h2 class="name">Generic Apolar Map</h2>
        <v-row>
          Generic apolar map combines the probe densities from benzene and
          propane. This map is useful for identifying the sites where
          hydrophobic moieties are likely to interact with the target protein.
        </v-row>
      </div>
      <div :class="[help == 'fragmap.hbdon' ? 'help-on' : 'help-off']">
        <h2 class="name">Generic Donor Map</h2>
        <v-row>
          Generic donor map combines the probe densities from methanol,
          formaldehyde, and imidazole. This map is useful for identifying the
          sites where hydrogen bond donor moieties are likely to interact with
          the target protein.
        </v-row>
      </div>
      <div :class="[help == 'fragmap.hbacc' ? 'help-on' : 'help-off']">
        <h2 class="name">Generic Acceptor Map</h2>
        <v-row>
          Generic acceptor map combines the probe densities from methanol,
          formaldehyde, and imidazole. This map is useful for identifying the
          sites where hydrogen bond acceptor moieties are likely to interact
          with the target protein.
        </v-row>
      </div>
      <div :class="[help == 'fragmap.meoo' ? 'help-on' : 'help-off']">
        <h2 class="name">Methanol Oxygen Map</h2>
        <v-row>
          The methanol oxygen map is constructed from the oxygen atom densities
          from the methanol probe molecules. This map is useful for identifying
          the sites where hydroxyls are favored. They are analyzed separately as
          they are both hydrogen bond donors and acceptors.
        </v-row>
      </div>
      <div :class="[help == 'fragmap.mamn' ? 'help-on' : 'help-off']">
        <h2 class="name">Methylammonium N Map</h2>
        <v-row>
          The methylammonium N map is constructed by the nitrogen atom densities
          from the methylammonium probe molecules. This map is useful for
          identifying the sites where positively charged moieties are likely to
          interact with the target protein.
        </v-row>
      </div>
      <div :class="[help == 'fragmap.acec' ? 'help-on' : 'help-off']">
        <h2 class="name">Acetate O Map</h2>
        <v-row>
          The acetate O map is constructed by the oxygen atom densities from the
          acetate probe molecules. This map is useful for identifying the sites
          where negatively charged moieties are likely to interact with the
          target protein.
        </v-row>
      </div>
    </div>
    <div class="navigation">
      <template v-if="active">
        <i class="el-icon-circle-close close" @click="toggle" />
      </template>
      <template v-else="active">
        <span class="open" @click="toggle">
          <i class="el-icon-information" />
          Help
        </span>
      </template>
    </div>
  </div>
</template>

<script>
// import Marked from 'marked'
// let renderer = new Marked.Renderer()

// Marked.setOptions({
//   renderer: renderer,
//   sanitize: true
// })

export default {
  name: "Fragmaphelp",
  data() {
    return {
      active: true,
    };
  },
  computed: {
    help() {
      return this.$store.state.help;
    },
  },
  methods: {
    toggle: function () {
      this.active = !this.active;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
